/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */
import App from './App.vue'
import { createApp } from 'vue'
import './assets/styles/main.scss'


const app = createApp(App)
Object.values(import.meta.glob('/src/modules/*.ts', { eager: true})).forEach((module: any) => module.install?.(app))
app.mount('#app')
